<template>
    <div style="padding: 10px;" class="addHairWork">
        <van-nav-bar
      title="新增作品"
      left-text="返回"
      left-arrow
      @click-left="historyBack"
    />
        <el-form ref="form" label-position="top" :model="addStaffWork" label-width="80px">
            <el-form-item label="作品名">
                <el-input v-model="addStaffWork.workname"></el-input>
            </el-form-item>
            <el-form-item label="上传3张作品图片">
                <van-uploader :file-list="fileList" max-count="3" @delete="deleteImg" :accept="image" :afterRead="afterRead" />
            </el-form-item>
            <el-button type="primary" style="width: 100%;" @click="saveHairWork" :loading="loading">保存</el-button>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading:false,
                fileList:[],
                squareUrl:"",
                addStaffWork:{},
                staffWork:{
                    staffid:"",
                    work1:"",
                    work2:"",
                    work3:"",
                    workname:"",
                },
                staffid:"",
            }
        },
        created:function(){
            this.staffid=this.$route.query.staffid;
        },
        methods:{
            deleteImg(event,index){
                let path=event.url.replace(this.baseImageUrl,"");
                this.$post("file/deleteFile",{path:path}).then(res=>{
                    if(res.sucess){
                        this.fileList.splice(index.index,1);
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
                console.log(event);
                console.log(index);
            },
            saveHairWork(){
                this.loading=true;
                if(!this.addStaffWork.workname){
                    this.$message({
                        message: "请输入作品名称",
                        type: 'error'
                    });
                    this.loading=false;
                    return;
                }
                if(this.fileList.length!=3){
                    this.$message({
                        message: "必须要上传3张图片",
                        type: 'error'
                    });
                    this.loading=false;
                    return;
                }
                let obj=new Object();
                obj.staffid=this.staffid;
                obj.work1=this.fileList[0].url;
                obj.work2=this.fileList[1].url;
                obj.work3=this.fileList[2].url;
                obj.workname=this.addStaffWork.workname;
                obj.work1=obj.work1.replace(this.baseImageUrl,"");
                obj.work2=obj.work2.replace(this.baseImageUrl,"");
                obj.work3=obj.work3.replace(this.baseImageUrl,"");
                obj.billtype=1;
                this.$postw("hairwork/saveHairWork",obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                            onClose:()=>{
                                window.history.back();
                                this.loading=false;
                            }
                        });
                    }
                    else{
                        this.loading=false;
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            afterRead(event){
                let formData = new FormData()
                formData.append('file', event.file);
                this.$upload("file/filePathUpload?path=staffwork",formData).then(res=>{
                    if(res.sucess){
                        let obj=new Object();
                        obj.deletable=true;
                        obj.url=this.baseImageUrl+res.object;
                        this.fileList.push(obj);
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .addHairWork .van-uploader__upload{
        width: 120px;
        height: 120px;
    }
    .addHairWork .van-uploader__preview-image{
        width: 120px;
        height: 120px;
    }
</style>



// WEBPACK FOOTER //
// src/page/hair/addhairwork.vue